module.exports = __webpack_public_path__ + "static/media/visa-card.db86feed.png";